export function scrollToTop() {
    $(".scroll-top").on("click", function () {
        $(this).removeClass("show");
        $("html, body").animate({scrollTop: 0}, 1000);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollToTop.js